import { Component } from '@angular/core';

@Component({
  selector: 'yt-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'admin-dashboard-ui';
}
